(function () {
  const STORAGE_KEY = 'ulpQuoteItems';
  const VOLUME_DISCOUNT_NOTICE_KEY = 'ulpVolumeDiscountNoticeShown';
  const VOLUME_DISCOUNT_THRESHOLD = 50;
  const PRICING = {
    embroidery: {
      setup: 65,
      price: 9,
      additionalLocation: 7,
    },
    vinyl: { setup: 20, designPrice: 17 },
    twill: { setup: 15, designPrice: 30 },
    sublimation: { setup: 20, designPrice: 25 },
    heatTransfer: {
      setup: 0,
      tiers: [
        { min: 1, max: 24, price: 7.21 },
        { min: 25, max: 74, price: 7.09 },
        { min: 75, max: 249, price: 6.97 },
      ],
    },
    screenPrinting: {
      screenChargePerColor: 35,
      tiers: [
        { min: 1, max: 11, prices: [11.34, 15.54, 19.96, 24.38, 28.8, 33] },
        { min: 12, max: 23, prices: [6.6, 7.38, 9.7, 11.7, 14.02, 16.12] },
        { min: 24, max: 47, prices: [4.44, 6.04, 7.82, 9.62, 11.3, 13.94] },
        { min: 48, max: 95, prices: [3.72, 4.76, 5.6, 6.56, 4.86, 4.32] },
        { min: 96, max: 191, prices: [3.22, 3.76, 4.38, 4.86, 5.48, 5.8] },
        { min: 192, max: 479, prices: [2.92, 3.54, 3.96, 4.32, 4.74, 5.16] },
        { min: 480, max: 999, prices: [2.72, 3.02, 3.44, 3.76, 4.06, 4.38] },
        { min: 2500, max: 4999, prices: [2.5, 2.7, 2.92, 3.02, 3.06, 3.16] },
      ],
    },
  };

  function readItems() {
    try {
      const items = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  }

  function writeItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    if (getTotalQuantity(items) <= VOLUME_DISCOUNT_THRESHOLD) {
      sessionStorage.removeItem(VOLUME_DISCOUNT_NOTICE_KEY);
    }
    updateQuoteCount();
  }

  function parseJson(value) {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function getSelectedVariant(productInfo, button) {
    const selectedVariant = productInfo?.querySelector('variant-selects [data-selected-variant]');
    return parseJson(selectedVariant?.textContent) || parseJson(button.dataset.defaultVariant);
  }

  function getQuantity(productInfo) {
    const input = productInfo?.querySelector('.quantity__input');
    const quantity = parseInt(input?.value, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getItemKey(item) {
    return String(item.variantId || item.productId);
  }

  function getOptionText(item) {
    if (!item.options || !item.options.length) return '';
    if (item.options.length === 1 && item.options[0] === 'Default Title') return '';
    return item.options.join(' / ');
  }

  function buildSummary(items) {
    if (!items.length) return '';

    const lines = ['Quote Request Items:'];
    items.forEach((item, index) => {
      lines.push('');
      lines.push(`${index + 1}. ${item.productTitle}`);
      const optionText = getOptionText(item);
      if (optionText) lines.push(`Variant: ${optionText}`);
      if (item.sku) lines.push(`SKU: ${item.sku}`);
      lines.push(`Quantity: ${item.quantity}`);
      lines.push(`Product URL: ${window.location.origin}${item.productUrl}`);
    });

    return lines.join('\n');
  }

  function getInputValue(form, selector) {
    return form.querySelector(selector)?.value?.trim() || '';
  }

  function getDisplayValue(value) {
    const labels = {
      'under-4x4': 'Under 4 in x 4 in',
      'over-4x4': 'Other',
    };
    return labels[value] || value;
  }

  function formatCreationDate(date = new Date()) {
    return new Intl.DateTimeFormat('en-US', {
      dateStyle: 'medium',
      timeStyle: 'short',
    }).format(date);
  }

  function buildEmailSummary(form, items, estimate, creationDate = formatCreationDate()) {
    if (!form) return '';
    const selectedLocations = getSelectedLocations(form);
    const productLines = items.length
      ? items.map((item, index) => {
          const optionText = getOptionText(item);
          return [
            `${index + 1}. ${item.productTitle}`,
            optionText ? `   Variant: ${optionText}` : '',
            item.sku ? `   SKU: ${item.sku}` : '',
            `   Quantity: ${item.quantity}`,
            `   Product URL: ${window.location.origin}${item.productUrl}`,
          ]
            .filter(Boolean)
            .join('\n');
        })
      : ['No products selected'];

    const selectedImprintType = getDisplayValue(getCheckedValue(form, '[data-estimate-imprint-type]')) || 'Not selected';
    const selectedDesignSize = getDisplayValue(getCheckedValue(form, '[data-estimate-design-size]')) || 'Not selected';
    const designColors = getFieldValue(form, '[data-estimate-colors]') || 'Not entered';

    const estimateLines =
      estimate.status === 'priced'
        ? [
            `Final Price: ${money(estimate.estimatedTotal)}`,
            `Set-up Fee: ${money(estimate.setupTotal)}`,
            `Product Total: ${money(estimate.productSubtotal)}`,
            `Imprint Total: ${money(estimate.imprintTotal)}`,
          ]
        : [
            'Final Price: TBD',
            `Product Total: ${typeof estimate.productSubtotal === 'number' ? money(estimate.productSubtotal) : 'TBD'}`,
            `Reason: ${estimate.title}`,
          ];

    return [
      `Creation Date: ${creationDate}`,
      '',
      'CUSTOMER',
      `Name: ${getInputValue(form, '[data-quote-customer-name]') || 'Not entered'}`,
      `Business: ${getInputValue(form, '[data-quote-business]') || 'Not entered'}`,
      `Email: ${getInputValue(form, '[data-quote-email]') || 'Not entered'}`,
      `Phone: ${getInputValue(form, '[data-quote-phone]') || 'Not entered'}`,
      '',
      'QUOTE ITEMS',
      ...productLines,
      '',
      'DECORATION',
      `Imprint Type: ${selectedImprintType}`,
      `Imprint Locations: ${selectedLocations.length ? selectedLocations.join(', ') : 'Not selected'}`,
      `Design Colors: ${designColors}`,
      `Design Size: ${selectedDesignSize}`,
      '',
      'ESTIMATE',
      ...estimateLines,
      '',
      'ADDITIONAL DETAILS',
      getInputValue(form, '[data-quote-details]') || 'None provided',
    ].join('\n');
  }

  function money(value) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
  }

  function getTotalQuantity(items) {
    return items.reduce((sum, item) => sum + (parseInt(item.quantity, 10) || 0), 0);
  }

  function getProductSubtotal(items) {
    return items.reduce((sum, item) => {
      const price = Number(item.price) || 0;
      const quantity = parseInt(item.quantity, 10) || 0;
      return sum + (price / 100) * quantity;
    }, 0);
  }

  function findTier(tiers, quantity) {
    return tiers.find((tier) => quantity >= tier.min && quantity <= tier.max);
  }

  function getFieldValue(form, selector) {
    return form.querySelector(selector)?.value?.trim() || '';
  }

  function getCheckedValue(form, selector) {
    return form.querySelector(`${selector}:checked`)?.value?.trim() || '';
  }

  function getSelectedLocations(form) {
    return Array.from(form.querySelectorAll('[data-estimate-location]:checked')).map((input) => input.value);
  }

  function getEstimateForm() {
    return document.querySelector('#QuoteRequestForm, #ContactForm');
  }

  function normalizeImprintType(value) {
    return value.toLowerCase().replace(/\s+/g, '-');
  }

  function customEstimate(title, reason, productSubtotal) {
    return {
      status: 'custom',
      title,
      productSubtotal,
      decorationTotal: null,
      setupTotal: null,
      imprintTotal: null,
      estimatedTotal: null,
      lines: [reason, `Estimated product subtotal: ${money(productSubtotal)}`],
      summary: [
        'Estimate: Custom quote required',
        reason,
        `Estimated product subtotal: ${money(productSubtotal)}`,
      ].join('\n'),
    };
  }

  function incompleteEstimate(productSubtotal) {
    return {
      status: 'incomplete',
      title: 'Complete estimate details',
      productSubtotal,
      decorationTotal: null,
      setupTotal: null,
      imprintTotal: null,
      estimatedTotal: null,
      lines: [`Estimated product subtotal: ${money(productSubtotal)}`],
      summary: `Estimate pending\nEstimated product subtotal: ${money(productSubtotal)}`,
    };
  }

  function pricedEstimate(productSubtotal, decorationTotal, setupTotal, note) {
    const imprintTotal = decorationTotal;
    const estimatedTotal = productSubtotal + decorationTotal + setupTotal;
    const lines = [
      `Estimated product subtotal: ${money(productSubtotal)}`,
      `Estimated set-up fee: ${money(setupTotal)}`,
      `Estimated imprint total: ${money(decorationTotal)}`,
      `Estimated total: ${money(estimatedTotal)}`,
      note,
    ];

    return {
      status: 'priced',
      title: `Estimated total: ${money(estimatedTotal)}`,
      productSubtotal,
      decorationTotal,
      setupTotal,
      imprintTotal,
      estimatedTotal,
      lines,
      summary: ['Estimate guesstimate:', ...lines].join('\n'),
    };
  }

  function calculateEstimate(form, items, overrideImprintType = null, options = {}) {
    const productSubtotal = getProductSubtotal(items);
    const quantity = getTotalQuantity(items);

    if (!items.length) {
      return {
        status: 'empty',
        title: 'Add products for an estimate',
        productSubtotal,
        decorationTotal: null,
        setupTotal: null,
        imprintTotal: null,
        estimatedTotal: null,
        lines: ['Your estimate will appear once products are in the quote.'],
        summary: 'Estimate pending: no quote items selected',
      };
    }

    const imprintType = normalizeImprintType(overrideImprintType || getCheckedValue(form, '[data-estimate-imprint-type]'));
    const designSize = getCheckedValue(form, '[data-estimate-design-size]');
    const colors = parseInt(getFieldValue(form, '[data-estimate-colors]'), 10);
    const locations = getSelectedLocations(form);
    const locationCount = options.preview ? Math.max(locations.length, 1) : locations.length;

    if (!imprintType || !designSize || !colors || locationCount < 1) {
      return incompleteEstimate(productSubtotal);
    }

    if (imprintType.includes('other')) {
      return customEstimate(
        'Custom quote required',
        'The selected imprint type needs review. Please add details below.',
        productSubtotal
      );
    }

    if (['vinyl', 'twill', 'sublimation'].includes(imprintType)) {
      return customEstimate(
        'Custom quote required',
        'This imprint type needs review by the sales team. Please submit the form for official pricing.',
        productSubtotal
      );
    }

    const isScreenPrinting = imprintType === 'screen-printing';
    const sizeLimitedTypes = ['embroidery', 'vinyl', 'twill', 'sublimation', 'heat-transfer'];

    if (sizeLimitedTypes.includes(imprintType) && designSize !== 'under-4x4') {
      return customEstimate(
        'Custom quote required',
        'Designs larger than 4 in. x 4 in. need a custom quote. Please submit the form or call in.',
        productSubtotal
      );
    }

    if (isScreenPrinting) {
      if (colors < 1 || colors > 6) {
        return customEstimate('Custom quote required', 'Screen printing estimates support 1-6 design colors.', productSubtotal);
      }

      const tier = findTier(PRICING.screenPrinting.tiers, quantity);
      if (!tier) {
        return customEstimate(
          'Custom quote required',
          'This screen printing quantity needs a custom quote.',
          productSubtotal
        );
      }

      const perItem = tier.prices[colors - 1];
      const decorationTotal = perItem * quantity * locationCount;
      const setupTotal = PRICING.screenPrinting.screenChargePerColor * colors * locationCount;
      return pricedEstimate(
        productSubtotal,
        decorationTotal,
        setupTotal,
        'Screen printing estimate includes a $35 screen charge per color, per location.'
      );
    }

    if (imprintType === 'embroidery') {
      const extraLocationCount = Math.max(locationCount - 1, 0);
      const perItem = PRICING.embroidery.price + extraLocationCount * PRICING.embroidery.additionalLocation;
      return pricedEstimate(
        productSubtotal,
        perItem * quantity,
        PRICING.embroidery.setup,
        'Embroidery estimate assumes a standard logo under 4 in. x 4 in.'
      );
    }

    if (imprintType === 'vinyl') {
      return customEstimate('Custom quote required', 'Vinyl pricing needs review by the sales team.', productSubtotal);
    }

    if (imprintType === 'twill') {
      return customEstimate('Custom quote required', 'Twill pricing needs review by the sales team.', productSubtotal);
    }

    if (imprintType === 'sublimation') {
      return customEstimate('Custom quote required', 'Sublimation pricing needs review by the sales team.', productSubtotal);
    }

    if (imprintType === 'heat-transfer') {
      const tier = findTier(PRICING.heatTransfer.tiers, quantity);
      if (!tier) {
        return customEstimate('Custom quote required', 'Heat transfer estimates are available for quantities from 1-249.', productSubtotal);
      }

      return pricedEstimate(
        productSubtotal,
        tier.price * quantity * locationCount,
        PRICING.heatTransfer.setup,
        'Heat transfer estimate assumes a standard design under 4 in. x 4 in.'
      );
    }

    return customEstimate('Custom quote required', 'This imprint type needs review by the sales team.', productSubtotal);
  }

  function getImprintDisplayTypes() {
    return [
      { value: 'Embroidery', selector: '[data-imprint-price=\"embroidery\"]' },
      { value: 'Screen Printing', selector: '[data-imprint-price=\"screen-printing\"]' },
      { value: 'Heat Transfer', selector: '[data-imprint-price=\"heat-transfer\"]' },
    ];
  }

  function getEstimateTotalFromSummary(summary) {
    const match = summary.match(/Estimated total:\s*(\$[\d,]+(?:\.\d{2})?)/);
    return match ? match[1] : 'TBD';
  }

  function updateImprintPrices(form, items) {
    getImprintDisplayTypes().forEach(({ value, selector }) => {
      const target = form.querySelector(selector);
      if (!target) return;
      const estimate = calculateEstimate(form, items, value, { preview: true });
      target.textContent = estimate.status === 'priced' ? money(estimate.imprintTotal) : 'TBD';
    });
  }

  function renderEstimate(estimate) {
    const box = document.querySelector('[data-quote-estimate]');
    const output = document.querySelector('[data-quote-estimate-output]');
    const finalPrice = document.querySelector('[data-final-price]');
    const setupTotal = document.querySelector('[data-setup-total]');
    const productTotal = document.querySelector('[data-product-total]');
    const imprintTotal = document.querySelector('[data-imprint-total]');
    const hidden = document.querySelector('[data-quote-estimate-summary]');
    const emailSummary = document.querySelector('[data-quote-email-summary]');
    const creationDate = document.querySelector('[data-quote-creation-date]');

    if (hidden) hidden.value = estimate.summary;
    if (creationDate && !creationDate.value) creationDate.value = formatCreationDate();
    if (emailSummary) {
      emailSummary.value = buildEmailSummary(
        getEstimateForm(),
        readItems(),
        estimate,
        creationDate?.value || formatCreationDate()
      );
    }
    if (finalPrice) finalPrice.textContent = estimate.status === 'priced' ? money(estimate.estimatedTotal) : 'TBD';
    if (setupTotal) setupTotal.textContent = estimate.status === 'priced' ? money(estimate.setupTotal) : 'TBD';
    if (productTotal) productTotal.textContent = typeof estimate.productSubtotal === 'number' ? money(estimate.productSubtotal) : 'TBD';
    if (imprintTotal) imprintTotal.textContent = estimate.status === 'priced' ? money(estimate.imprintTotal) : 'TBD';
    if (!box || !output) return;

    box.dataset.estimateStatus = estimate.status;
    output.replaceChildren();

    const title = document.createElement('p');
    title.className = 'quote-estimate__title';
    title.textContent = estimate.title;

    const list = document.createElement('ul');
    list.className = 'quote-estimate__list';
    estimate.lines.forEach((line) => {
      const item = document.createElement('li');
      item.textContent = line;
      list.append(item);
    });

    output.append(title, list);
  }

  function updateEstimator() {
    const form = getEstimateForm();
    if (!form || !form.querySelector('[data-quote-estimate-summary]')) return;
    const items = readItems();
    updateImprintPrices(form, items);
    updateLocationSummary(form);
    renderEstimate(calculateEstimate(form, items));
  }

  function updateLocationSummary(form) {
    const target = form.querySelector('[data-estimate-locations-summary]');
    if (!target) return;
    const locations = getSelectedLocations(form);
    target.value = locations.length ? locations.join(', ') : '';
  }

  function updateQuoteCount() {
    const count = readItems().length;
    document.querySelectorAll('[data-quote-label]').forEach((label) => {
      label.textContent = count > 0 ? `QUOTE (${count})` : 'QUOTE';
    });
    document.querySelectorAll('[data-quote-count]').forEach((bubble) => {
      bubble.textContent = count > 0 ? count : '';
      bubble.classList.toggle('hidden', count === 0);
    });
  }

  function closeQuoteModal(modal) {
    modal?.setAttribute('hidden', '');
  }

  function ensureVolumeDiscountModal() {
    let modal = document.querySelector('[data-quote-volume-modal]');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'quote-success-modal quote-volume-modal';
    modal.dataset.quoteVolumeModal = '';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'QuoteVolumeDiscountTitle');
    modal.innerHTML = `
      <div class="quote-success-modal__panel">
        <button type="button" class="quote-success-modal__close" data-quote-volume-close aria-label="Close">&times;</button>
        <h2 id="QuoteVolumeDiscountTitle">Additional Volume Discounts</h2>
        <p>Your order may qualify for additional volume discounts. Please contact us at sales@uslegacypromotions.com</p>
        <button type="button" class="button quote-success-modal__button" data-quote-volume-close>Close</button>
      </div>
    `;
    document.body.append(modal);
    return modal;
  }

  function maybeShowVolumeDiscountNotice(items) {
    if (getTotalQuantity(items) <= VOLUME_DISCOUNT_THRESHOLD) return;
    if (sessionStorage.getItem(VOLUME_DISCOUNT_NOTICE_KEY) === 'true') return;

    sessionStorage.setItem(VOLUME_DISCOUNT_NOTICE_KEY, 'true');
    ensureVolumeDiscountModal().removeAttribute('hidden');
  }

  function addQuoteItem(button) {
    const productInfo = button.closest('product-info');
    const variant = getSelectedVariant(productInfo, button);
    if (!variant || !variant.id) return;

    const quantity = getQuantity(productInfo);
    const newItem = {
      productId: button.dataset.productId,
      productTitle: button.dataset.productTitle,
      productHandle: button.dataset.productHandle,
      productUrl: button.dataset.productUrl,
      productVendor: button.dataset.productVendor,
      productImage: button.dataset.productImage,
      variantId: variant.id,
      variantTitle: variant.title,
      options: variant.options || [],
      sku: variant.sku || '',
      price: variant.price,
      quantity,
    };

    const items = readItems();
    const existingItem = items.find((item) => getItemKey(item) === getItemKey(newItem));

    if (existingItem) {
      existingItem.quantity += quantity;
    } else {
      items.push(newItem);
    }

    writeItems(items);
    renderQuotePage();

    const status = button.closest('.quote-product-actions')?.querySelector('[data-quote-add-status]');
    if (status) {
      status.innerHTML = 'Added to quote. <a href="/pages/quote">View quote</a>';
      window.setTimeout(() => {
        status.textContent = '';
      }, 5000);
    }
  }

  function createItemElement(item, index) {
    const wrapper = document.createElement('article');
    wrapper.className = 'quote-request__item';

    const image = document.createElement('img');
    image.className = 'quote-request__image';
    image.alt = '';
    image.loading = 'lazy';
    if (item.productImage) {
      image.src = item.productImage;
    }

    const body = document.createElement('div');

    const title = document.createElement('a');
    title.className = 'quote-request__item-title';
    title.href = item.productUrl;
    title.textContent = item.productTitle;

    const meta = document.createElement('p');
    meta.className = 'quote-request__meta';
    const optionText = getOptionText(item);
    meta.textContent = [optionText, item.sku ? `SKU: ${item.sku}` : ''].filter(Boolean).join(' | ');

    const controls = document.createElement('div');
    controls.className = 'quote-request__item-controls';

    const quantity = document.createElement('input');
    quantity.className = 'field__input quote-request__qty';
    quantity.id = `QuoteItemQty-${index}`;
    quantity.type = 'number';
    quantity.min = '1';
    quantity.setAttribute('aria-label', `Quantity for ${item.productTitle}`);
    quantity.value = item.quantity;
    quantity.dataset.quoteQuantity = String(index);

    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'link underlined-link quote-request__remove';
    remove.dataset.quoteRemove = String(index);
    remove.textContent = 'Remove';

    controls.append(quantity, remove);
    body.append(title, meta, controls);
    wrapper.append(image, body);

    return wrapper;
  }

  function renderQuotePage() {
    const list = document.querySelector('[data-quote-items]');
    const empty = document.querySelector('[data-quote-empty]');
    const clear = document.querySelector('[data-quote-clear]');
    const summary = document.querySelector('[data-quote-summary]');
    if (!list || !summary) return;

    const items = readItems();
    list.replaceChildren(...items.map(createItemElement));
    empty?.toggleAttribute('hidden', items.length > 0);
    clear?.toggleAttribute('hidden', items.length === 0);
    summary.value = buildSummary(items);
    updateEstimator();
    maybeShowVolumeDiscountNotice(items);
  }

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('[data-quote-add]');
    if (addButton) {
      event.preventDefault();
      addQuoteItem(addButton);
      return;
    }

    const removeButton = event.target.closest('[data-quote-remove]');
    if (removeButton) {
      const items = readItems();
      items.splice(Number(removeButton.dataset.quoteRemove), 1);
      writeItems(items);
      renderQuotePage();
      return;
    }

    if (event.target.closest('[data-quote-clear]')) {
      writeItems([]);
      renderQuotePage();
      return;
    }

    if (event.target.closest('[data-quote-success-close]') || event.target.matches('[data-quote-success-modal]')) {
      const modal = event.target.closest('[data-quote-success-modal]') || document.querySelector('[data-quote-success-modal]');
      closeQuoteModal(modal);
    }

    if (event.target.closest('[data-quote-volume-close]') || event.target.matches('[data-quote-volume-modal]')) {
      const modal = event.target.closest('[data-quote-volume-modal]') || document.querySelector('[data-quote-volume-modal]');
      closeQuoteModal(modal);
    }
  });

  document.addEventListener('change', (event) => {
    const quantityInput = event.target.closest('[data-quote-quantity]');
    if (!quantityInput) return;

    const items = readItems();
    const index = Number(quantityInput.dataset.quoteQuantity);
    const quantity = parseInt(quantityInput.value, 10);

    if (items[index] && Number.isFinite(quantity) && quantity > 0) {
      items[index].quantity = quantity;
      writeItems(items);
      renderQuotePage();
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('#QuoteRequestForm, #ContactForm');
    if (!form || !form.querySelector('[data-quote-summary]')) return;

    const error = form.querySelector('[data-quote-error]');
    const summary = form.querySelector('[data-quote-summary]');
    const estimateSummary = form.querySelector('[data-quote-estimate-summary]');
    const emailSummary = form.querySelector('[data-quote-email-summary]');
    const creationDate = form.querySelector('[data-quote-creation-date]');
    const items = readItems();
    const estimate = calculateEstimate(form, items);
    const submittedAt = formatCreationDate();
    updateLocationSummary(form);
    if (creationDate) creationDate.value = submittedAt;
    if (summary) summary.value = buildSummary(items);
    if (estimateSummary) estimateSummary.value = estimate.summary;
    if (emailSummary) emailSummary.value = buildEmailSummary(form, items, estimate, submittedAt);

    if (!items.length) {
      event.preventDefault();
      if (error) error.textContent = 'Please add at least one product to your quote before submitting.';
    } else if (form.querySelector('[data-estimate-location]') && !getSelectedLocations(form).length) {
      event.preventDefault();
      if (error) error.textContent = 'Please select at least one imprint location.';
    } else if (error) {
      error.textContent = '';
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    updateQuoteCount();
    renderQuotePage();
    updateEstimator();
    document.querySelector('[data-quote-success-modal]')?.removeAttribute('hidden');
  });

  document.addEventListener('shopify:section:load', () => {
    updateQuoteCount();
    renderQuotePage();
    updateEstimator();
  });

  document.addEventListener('input', (event) => {
    if (event.target.closest('[data-estimate-field]')) updateEstimator();
  });

  document.addEventListener('change', (event) => {
    if (event.target.closest('[data-estimate-field]')) updateEstimator();
  });
})();
